import { FileText, FileSpreadsheet, FileCode, File } from 'lucide-react';

/**
 * Get the appropriate icon component for a document type
 * @param type The file type (pdf, docx, xlsx, txt, etc.)
 * @returns Lucide icon component
 */
export function getDocumentIcon(type: string) {
  const lowerType = type.toLowerCase();

  switch (lowerType) {
    case 'pdf':
      return FileText;
    case 'docx':
    case 'doc':
      return FileText;
    case 'xlsx':
    case 'xls':
    case 'csv':
      return FileSpreadsheet;
    case 'txt':
    case 'md':
    case 'json':
    case 'xml':
      return FileCode;
    default:
      return File;
  }
}

/**
 * Get the appropriate color class for a document based on its scope
 * @param scope 'private' or 'shared'
 * @returns Tailwind CSS color class
 */
export function getDocumentIconColor(scope: 'private' | 'shared') {
  return scope === 'private' ? 'text-blue-400' : 'text-purple-400';
}

/**
 * Get a display-friendly label for the document scope
 * @param scope 'private' or 'shared'
 * @returns Display label
 */
export function getScopeLabel(scope: 'private' | 'shared') {
  return scope === 'private' ? 'Privado' : 'Compartido';
}

/**
 * Get Tailwind CSS classes for a document type badge.
 * Consistent colors across all views (sidebar, citations, references).
 * @param docType Document type string (FECU, ANALISIS, HE, MEMORIA, XBRL, etc.)
 * @returns Tailwind CSS class string for text color + background
 */
export function getDocTypeBadgeClass(docType: string | undefined | null): string {
  if (!docType) return '';
  switch (docType.toUpperCase()) {
    case 'FECU':
      return 'text-blue-400 bg-blue-400/10';
    case 'ANALISIS':
      return 'text-emerald-400 bg-emerald-400/10';
    case 'HE':
      return 'text-amber-400 bg-amber-400/10';
    case 'MEMORIA':
      return 'text-purple-400 bg-purple-400/10';
    case 'XBRL':
      return 'text-cyan-400 bg-cyan-400/10';
    default:
      return 'text-gray-400 bg-gray-400/10';
  }
}
